import { GatsbyImage, getImage } from "gatsby-plugin-image"

import React from "react"

export const ImageTitle = ({ image, seo_title }) => {
  const image_data = getImage(image)

  const {
    fields: {
      caption,
      focus_point: { x, y },
    },
  } = image

  return (
    <div className="p-3 mb-5">
      <figure className="image bfz-title-image">
        <GatsbyImage
          image={image_data}
          loading="eager"
          alt={seo_title}
          title={seo_title}
          style={{ maxHeight: 500 }}
          imgStyle={{ maxHeight: 500 }}
          objectPosition={
            !!x ? `${Math.round(100 * x)}% ${Math.round(100 * y)}%` : undefined
          }
        />
        <figcaption>{caption}</figcaption>
      </figure>
    </div>
  )
}
